<template>
  <div class="icon">
    <img :src="iconUrl" :style="styles">
    <!-- <svg :class="iconClass" :style="{styles}" aria-hidden="true">
      <use :xlink:href="iconUrl"></use>
    </svg> -->
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    iconClass: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 24
    },
    imgType: {
      type: String,
      default: 'svg'
    }
  },
  computed: {
    iconUrl () {
     return require(`../../assets/icon/${this.type}.${this.imgType}`);
    },
    styles () {
      return {
        fontSize: `${this.size}px`,
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    }
  }
}
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
}
</style>